import React from "react";
import { List } from "lucide-react";
import { useCart } from "../../contexts/CartContext";

function HeaderCartButton({ className = "" }) {
  const { itemCount } = useCart();

  if (itemCount === 0) return null;

  return (
    <span className={`shopping-cart-region results-header-shopping-cart-region ${className}`.trim()}>
      <a
        className="shopping-cart-icon search-results-view-tab"
        href="/cart"
      >
        <List aria-hidden="true" size={16} strokeWidth={1.8} />
        <span>My Resource List ({itemCount})</span>
      </a>
    </span>
  );
}

export default HeaderCartButton;
